import axios from "axios";
import config from "../config";
import infoDialog from "../components/info-dialog";

export default class Axios {
  constructor(fullLoader = true, headers = {}) {
    this._headers = headers;
    this.axios = this._createInstance();
    this._registerRequestInterceptor(fullLoader);
    this._registerResponseInterceptor(fullLoader);
  }

  _createInstance() {
    if (localStorage.getItem("onlyDigitalMenu") != null) {
      if (localStorage.getItem("onlyDigitalMenu").toString() === "true") {
        localStorage.removeItem("tokenExpiration");
      }
    }
    if (localStorage.getItem("tokenExpiration") != null) {
      const expiration =
        localStorage
          .getItem("tokenExpiration")
          .split(" ")[0]
          .split("/")
          .reverse()
          .join("/") +
        " " +
        localStorage.getItem("tokenExpiration").split(" ")[1];
      if (new Date() > new Date(expiration)) {
        localStorage.removeItem("accessToken");
      }
    }
    const token = localStorage.getItem("accessToken");
    if (token) {
      this._headers.Authorization = "Bearer " + token;
    } else {
      infoDialog.open(
        "Token Expirado",
        "Por favor leia novamente o QRCode para confirmar sua localização.",
        "error"
      );
    }
    return axios.create({
      baseURL: config[process.env.NODE_ENV].api,
      timeout: 300000,
      headers: this._headers,
    });
  }

  _registerRequestInterceptor(fullLoader) {
    if (fullLoader) {
      // app.$loading.open();
    }

    this.axios.interceptors.request.use(async (config) => {
      // Se quiser fazer algo na request, faça aqui
      return config;
    });
  }

  _registerResponseInterceptor(fullLoader) {
    if (fullLoader) {
      // app.$loading.close();
    }
    this.axios.interceptors.response.use(
      (response) => {
        if (
          response.headers["x-token"] != null &&
          response.headers["x-token"] !== ""
        ) {
          localStorage.setItem("accessToken", response.headers["x-token"]);
        }
        return response;
      },
      async (error) => {
        if (error.response.status < 500) {
          return Promise.reject(error.response.data);
        }
        if (error.code === "ECONNABORTED") {
          return;
        }
        if (
          error.response.data.message ===
          "A sessão expirou ou é inválida, faça o login novamente"
        ) {
          throw error.response.data.message;
        }
        return Promise.reject(error);
      }
    );
  }
}
